import { signal } from "@angular/core";
import { OrganizationMicroService } from "../../services/organization.micro.service";
import { S25ItemI } from "../../pojo/S25ItemI";
import { StudentEngagementOrg } from "./StudentEngagementOrg";
import { CustomAttributes } from "../../pojo/CustomAttributes";
import { MicroUtil } from "../../services/MicroServices/micro.util";
import { CustomAttributeService } from "../../services/custom.attribute.service";
import { S25Util } from "../../util/s25-util";

export class StudentEngagementService {
    public static async getOrganizationDetails(itemId: number): Promise<StudentEngagementOrg.details> {
        const organization = await OrganizationMicroService.getOrganizationIncludes(
            itemId,
            ["contacts", "attributes"],
            true,
        );
        const details = organization.data.items[0];
        const expandedInfo = organization.expandedInfo[0];

        let imageCAURL = details.attributes.find(
            (attr) => attr.attributeId === CustomAttributes.system.orgImage.id,
        )?.value;
        imageCAURL = CustomAttributeService.getCAFilePreviewUrl(imageCAURL);
        const mission =
            details.attributes.find((attr) => attr.attributeId === CustomAttributes.system.orgMission.id)?.value ||
            "No mission statement provided";

        const membersArr = S25Util.array
            .forceArray(expandedInfo.contacts)
            .filter((cont) => !!details.contacts.find((c) => c.contactId === cont.contactId))
            .map((cont) => {
                const contactDetails = MicroUtil.getContactDetails(cont.contactId, [cont]);
                return { ...contactDetails, itemId: cont.contactId, itemName: contactDetails.fullName };
            });
        const members = signal<S25ItemI[]>(membersArr);
        const primaryContact = membersArr[0]; //TODO: implement primary contact logic

        return {
            name: details.organizationName,
            mission: mission,
            primaryContact: primaryContact,
            members: members,
            image: imageCAURL,
        };
    }
}
